import Vue from 'vue'
import toastr from '../toastr'
import VueMultiselect from 'vue-multiselect'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import { NTFY_DE_ID, NTFY_ID, NTFY_CZ_ID } from '../../const/common.js'
import TextInput from '../../component/dccore-form/textInput.vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import Multiselect from '../../component/dccore-form/multiselect.vue'
import Checkbox from '../../component/dccore-form/checkbox.vue'
import Ckeditor from '../../component/dccore-form/ckeditor.vue'
import UploadPhoto from '../../component/dccore-form/uploadPhoto.vue'

if ($('#variant_form').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#variant_form',
    components: {
      VueMultiselect,
      Singleselect,
      Multiselect,
      RingLoader,
      Checkbox,
      TextInput,
      NumberInput,
      Ckeditor,
      UploadPhoto
    },
    mixins: [mixins],
    data: {
      loading: 0,
      form: {
        entity: {
          active: true,
          brand: null
        },
        options: {
          errors: {},
          brands: [],
          types: [],
          materialCategories: [],
          materialsPortions: [],
          mealWorkTag: [],
          allergens: [],
          mealsFinal: [],
          mealsComponent: [],
          otherVariants: [],
          packages: [],
        }
      },
      entityId: null,
    },
    created() {
      this.NTFY_DE_ID = NTFY_DE_ID
      this.NTFY_CZ_ID = NTFY_CZ_ID
    },
    mounted() {
      this.loading++

      this.getBrands()
      this.getTypes()
      this.getMaterialsCategory()
      this.getMaterialsPortions()
      this.getMealWorkTag()
      this.getAllergens()
      this.getFinalMeals()
      this.getComponentMeals()
      this.getOtherVariants()
      this.getPackages()
      this.getPLVariants()

      if ($('#entity_id').length) {
        this.entityId = $('#entity_id').val()
        this.getVariant()
      }

      this.loading--
    },
    methods: {
      createVariant(redirect) {
        let url = Routing.generate('api_post_variant')

        let data = { data: this.form.entity }

        this.loading++
        this.$http.post(url, data).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('variant_grid'))
          } else {
            toastr.success(Translator.trans('form.created'))
            this.form.options.errors = {}
          }
          this.loading--

        }, response => {
          this.loading--
          this.handleAjaxError(response, this.form.options)
        })

      },
      updateVariant(redirect) {
        this.loading++
        let url = Routing.generate('api_patch_variant', {
          id: this.entityId,
        })

        let data = { data: this.form.entity }

        this.$http.patch(url, data).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('variant_grid'))
          } else {
            toastr.success(Translator.trans('form.updated'))
            this.form.options.errors = {}
          }
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response, this.form.options)
        })
      },
      getVariant() {
        this.loading++
        let url = Routing.generate('api_get_variant', { id: this.entityId,
          context: 'edit' })

        this.$http.get(url).then(response => {
          let selectedBrand = response.data.selectedBrand
          delete response.data.selectedBrand
          response.data.brand = selectedBrand.id

          this.form.entity = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getBrands() {
        let url = Routing.generate('api_get_brands', { context: 'dropdown' })
        this.loading++
        this.$http.get(url).then(response => {
          this.form.options.brands = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getTypes() {
        this.loading++
        let url = Routing.generate('api_get_variants_types')
        this.$http.get(url).then(response => {
          this.loading--
          this.form.options.types = response.data
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getPLVariants() {
        this.loading++
        let url = Routing.generate('api_get_variants_for_brand', {
          brand: NTFY_ID,
          context: 'list'
        })
        this.$http.get(url).then(response => {
          this.loading--
          this.form.options.variantsPL = response.data
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getMaterialsCategory() {
        let url = Routing.generate('api_get_tags', { type: 'portion_category',
          context: 'dropdown' })
        this.loading++
        this.$http.get(url).then(response => {
          this.form.options.materialCategories = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getMaterialsPortions() {
        let url = Routing.generate('api_get_materials_portions', { context: 'dropdown' })
        this.loading++
        this.$http.get(url).then(response => {
          this.form.options.materialsPortions = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getMealWorkTag() {
        this.loading++
        let url = Routing.generate('api_get_tags', { 'type': 'meal_work_tag',
          context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.form.options.mealWorkTag = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getAllergens() {
        this.loading++
        let url = Routing.generate('api_get_tags', { 'type': 'allergen',
          context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.form.options.allergens = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getFinalMeals() {
        this.loading++
        let url = Routing.generate('api_get_meals_by_kind', { context: 'dropdown',
          kind: 'final_meal' })
        this.$http.get(url).then(response => {
          this.form.options.mealsFinal = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getComponentMeals() {
        this.loading++
        let url = Routing.generate('api_get_meals_by_kind', { context: 'dropdown',
          kind: 'component_meal' })
        this.$http.get(url).then(response => {
          this.form.options.mealsComponent = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getOtherVariants() {
        this.loading++
        let url = Routing.generate('api_get_variants', { context: 'other_variants' })
        this.$http.get(url).then(response => {
          this.form.options.otherVariants = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getPackages() {
        this.loading++
        let url = Routing.generate('api_get_packages', { context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.form.options.packages = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      translateType(name) {
        return Translator.trans(`variant.entity.types.${name}`)
      },
    }
  })
}
